import withNavigate from "../../../routes/withNavigate.jsx";
import ContactPageCmsContainer from "./ContactPageCmsContainer.jsx";
import ContactPageCmsStore from "./ContactPageCmsStore.js";

export default ContactPageCmsStore(withNavigate(ContactPageCmsContainer));